import React from 'react'
import { useEnvValue, useWillPipe } from '@morningtrain/react-helpers'
import { toast } from 'react-toastify'
import { useTranslation } from '@morningtrain/react-translations'
import Error from 'widgets/alerts/Error'

export default function ValidateAllItemsHasReceivedOnPipe () {
  const errorMessage = useTranslation('smartviews.order_overview.errors.missing_received')
  const [items] = useEnvValue('globals.inventory.order_items', [])

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      let allHasReceived = true
      let anyHasShouldOfficeHandle = false

      const itemsAsArray = Object.values(items)

      if (itemsAsArray.length > 0) {
        itemsAsArray.forEach(item => {
          if (!!item.total && (item.received === null || typeof item.received === 'undefined')) {
            allHasReceived = false
          }
          if (item.who_should_handle_offset === 'office') {
            anyHasShouldOfficeHandle = true
          }
        })
      } else {
        allHasReceived = false
      }

      payload.all_has_received = allHasReceived
      payload.any_has_should_office_handle = anyHasShouldOfficeHandle

      if (allHasReceived) {
        resolve(payload)
      } else {
        toast.error(<Error message={errorMessage} />, {
          containerId: 'errorContainer'
        })
        reject(new Error('Not all items has received'))
      }
    })
  }, [errorMessage, items])

  return null
}
